"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_HUNDRED_PERCENT = exports.MODAL_MAX_HEIGHT_PERCENTAGE = exports.BC_MODAL_CONTAINER = exports.SECONDARY_TASK = exports.MAIN_TASK = exports.CLOSE_STATE_MODAL = exports.OPEN_STATE_MODAL = exports.BC_MODAL_OVERLAY = exports.BC_MODAL_CONTENT = exports.BC_MODAL_TITLE_LABEL = exports.BC_MODAL_TITLE = exports.BC_MODAL_BUTTON_CONTAINER = exports.BC_MODAL_CLOSE = exports.MODAL_ACTIVE = exports.MODAL = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.MODAL = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal");
exports.MODAL_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-active");
exports.BC_MODAL_CLOSE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-close-button");
exports.BC_MODAL_BUTTON_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-button-container");
exports.BC_MODAL_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-title");
exports.BC_MODAL_TITLE_LABEL = "modal-title-label";
exports.BC_MODAL_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-content");
exports.BC_MODAL_OVERLAY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-overlay");
exports.OPEN_STATE_MODAL = 1;
exports.CLOSE_STATE_MODAL = 0;
exports.MAIN_TASK = 1;
exports.SECONDARY_TASK = 0;
exports.BC_MODAL_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-modal-container");
exports.MODAL_MAX_HEIGHT_PERCENTAGE = 96;
exports.ONE_HUNDRED_PERCENT = 100;
